<br/>
<div style="text-align: center ">
    <h1>Solicitar Convenio</h1>
</div>


<br/>

<div class="container principal" style="border:0px solid #000000;background-color: white; padding-top: 10px; padding-bottom:50px">
    <form #convenioForm=ngForm>
        <div class="container principal">
            <p><b>Manual de convenio: </b> <a href="{{this.linkTexto}}" target="_blank">
                Convenio</a>.</p>     
            <br/>
            <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

                <div class="row">

                    <div class="col-lg-4"> Afiliado:</div>

                    <div class="col-lg-8">
                        <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                        </h2>

                    </div>

                </div>

            </div>
            <div *ngIf="rol != 'ROLE_AFILIADO'">

                <div class="row line">

                    <div class="col-lg-2"> </div>

                    <div class="col-lg-2">
                        <h2> Rut Afiliado </h2>
                    </div>

                    <div class="col-lg-4">

                        <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="buscador.rutAfiliado" #rutAfiliado="ngModel" class="form-control" type="text" required placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>



                    <div class="col-lg-4">

                        <button class="btn btn-primary" id="btnvalida" (click)="buscaCodeudor(buscador.rutAfiliado,3)" [disabled]="rutAfiliado.invalid">

                    Buscar

                </button>
                        <br/>
                    </div>
                    <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                        <div *ngIf="convenio.errors.required"> Ingrese un afiliado. </div>

                    </div>
                </div>
                <div class="row line">

                    <div class="col-lg-4"> </div>
                    <div class="col-lg-5">
                        <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                        </h2>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-lg-3">
                    <h1>Datos Convenio</h1>
                </div>
            </div>
            <br>
            <div class="row line">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p>Monto Solictado</p>
                </div>

                <div class="col-lg-6">
                    <input matInput type="number" id="montoSolicitado" value="{{this.convenio.montoSolicitado}}" name="montoSolicitado" [(ngModel)]="convenio.montoSolicitado" #montoSolicitado="ngModel" placeholder="Monto Máximo Disponible" required max="{{this.totalMaximo}}">
                </div>
                <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                    <div *ngIf="convenio.errors.required"> Ingrese el Monto a solicitar para convenio. </div>

                </div>
                <div class="col-lg-1"> </div>
                <div class="col-lg-1"> </div>
                <br>
            </div>


            <br/>
            <div class="row line">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p>Valor Capacidad de Descuento Mensual</p>
                </div>

                <div class="col-lg-6">
                    <input matInput type="number" id="capacidadDescuento" value="{{this.convenio.capacidadDescuento}}" name="capacidadDescuento" [(ngModel)]="convenio.capacidadDescuento" #capacidadDescuento="ngModel" placeholder="Monto Máximo Disponible" disabled>

                </div>
                <div class="col-lg-1"> </div>
                <div class="col-lg-1"> </div>
                <br>
            </div>
            <br/>
            <div class="row line">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p>Categoría de atención </p>
                </div>

                <div class="col-lg-6">
                    <mat-select [(ngModel)]="convenio.idTipoConvenio" class="form-control" id="idTipoConvenio" name="idTipoConvenio" required #idTipoConvenio="ngModel" (selectionChange)="habilitaDental(this.idTipoConvenio.value)">

                        <mat-option value="0">

                            SELECCIONE....

                        </mat-option>
                        <mat-option *ngFor="let categoria of categorias" value="{{categoria.id}}">
                            {{categoria.descripcion}}

                        </mat-option>
                    </mat-select>
                    <br>
                    <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                        <div *ngIf="convenio.errors.required"> Seleccione una categoría. </div>

                    </div>
                </div>
            </div>
            <br/>
            <div class="table-responsive" *ngIf="this.visible==true">

                <table class="table" name="tablaCargaDental" id="tablaCargaDental">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col"> Rut </th>

                            <th scope="col"> Nombre y Apellido </th>

                            <th scope="col"> Parentesco </th>

                            <th scope="col"> Edad </th>

                            <th scope="col"> Sexo </th>

                            <th scope="col"> Seleccionar </th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let postulante of postulantes; let i = index">

                            <td style="text-align: center;"> {{postulante.rut + '-' + postulante.dv}} </td>

                            <td style="text-align: center;">{{postulante.nombres + ' ' + postulante.apellidoPaterno }} </td>

                            <td style="text-align: center;"> {{postulante.parentesco}} </td>

                            <td style="text-align: center;"> {{postulante.fechaNacimiento}} </td>

                            <td style="text-align: center;"> {{postulante.sexo.nombre}} </td>

                            <td style="text-align: center;">

                                <input type="radio" name="postulante" [(ngModel)]="this.beneficiario" value="{{i}}" (click)="sumarReembolso(i)" required>
                            </td>

                        </tr>

                    </tbody>

                </table>

            </div> <br/> <br/>
            <br/>
            <div class="row line">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p>Región</p>
                </div>

                <div class="col-lg-6">

                    <mat-select class="form-control" id="idRegion" name="idRegion" required [(ngModel)]="convenio.idRegion" #idRegion="ngModel">

                        <mat-option value="0">

                            SELECCIONE....
                        </mat-option>

                        <mat-option *ngFor="let region of regiones" value="{{region.id}}">
                            {{region.nombre}}
                        </mat-option>
                    </mat-select>
                    <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                        <div *ngIf="convenio.errors.required">Seleccione una región. </div>
 
                    </div>
                </div>
              <!---   <div class="col-lg-1"> </div>
                <div class="col-lg-1"><button class="btn btn-info" (click)="buscaProveedor()">Buscar Proveedor</button> </div>
                -->
                <br>
            </div>
            <br/>
    <!--  <div *ngIf="rol != 'ROLE_AFILIADO'"> -->
        <br>
        <div class="row line">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3">
                <p>  </p>
            </div>
            <div class="col-lg-3">
                <div class="col-lg-1"><button class="btn btn-info"  style='width:230px;' (click)="buscaProveedor()">Buscar Proveedor</button> </div>
            </div>
        </div>
        <br/>
     <!--</div>-->



            <div class="row line">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p>Proveedor </p>
                </div>
                <div class="col-lg-6">

                    <mat-select [(ngModel)]="convenio.idProveedor" class="form-control" id="idProveedor" name="idProveedor" required #idProveedor="ngModel" (selectionChange)="buscarCantidadCuotas()">

                        <mat-option value="0">

                            SELECCIONE....

                        </mat-option>

                        <mat-option *ngFor="let proveedor of proveedores" value="{{proveedor.id}}">

                            {{proveedor.descripcion}}

                        </mat-option>

                    </mat-select>
                    <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                        <div *ngIf="convenio.errors.required"> Seleccione un proveedor. </div>

                    </div>

                </div>
                <div class="col-lg-1"> </div>
                <div class="col-lg-1"> </div>
            </div>


            <br>
          <!--  <div *ngIf="rol != 'ROLE_AFILIADO'"> -->

                <div class="row line">

                    <div class="col-lg-1"> </div>

                    <div class="col-lg-3">
                        <p> Número de Presupuesto </p>
                    </div>

                    <div class="col-lg-4">

                        <input id="numPresupuesto" name="numPresupuesto" [(ngModel)]="convenio.numPresupuesto" #numPresupuesto="ngModel" class="form-control" type="text" (keypress)="numberOnly($event)" autocomplete=off required onPaste="return false" />

                    </div>



                </div>
             <!--</div>-->

            <br>


            <div class="row line">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p>Cantidad de cuotas </p>
                </div>
                <div class="col-lg-2">
                    <mat-select class="form-control" id="idCantidadCuota" name="idCantidadCuota" [(ngModel)]="convenio.idCantidadCuota" #idCantidadCuota="ngModel" required>
                        <mat-option value="0">

                            SELECCIONE....

                        </mat-option>
                        <mat-option *ngFor="let cuota of this.cuotas" value="{{cuota.id}}">

                            {{cuota.descripcion}}

                        </mat-option>

                    </mat-select>


                </div>

                <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                    <div *ngIf="convenio.errors.required"> Seleccione Cantidad de Cuotas. </div>

                </div>
                <div class="col-lg-1"> </div>
                <div class="col-lg-1"> </div>

            </div>
            <br>
            <div class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar presupuesto</p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="convenio.archivoTest" (change)="seleccionaArchivo($event, 0)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"> </div>
                <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                    <div *ngIf="convenio.errors.required"> Ingrese al menos un (1) archivo. </div>

                </div>
            </div>
            <br/>
            <div *ngIf="cantidadArchivos > 1" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (2) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo2" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="convenio.archivoTest2" (change)="seleccionaArchivo($event, 1)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br/>
            <div *ngIf="cantidadArchivos > 2" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (3) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo3" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="convenio.archivoTest3" (change)="seleccionaArchivo($event, 2)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br/>
            <div *ngIf="cantidadArchivos > 3" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (4) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo4" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="convenio.archivoTest4" (change)="seleccionaArchivo($event, 3)">

                </div>

                <div class="col-lg-1"> </div>
                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>


                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br/>
            <div *ngIf="cantidadArchivos > 4" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (5) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo5" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="convenio.archivoTest5" (change)="seleccionaArchivo($event, 4)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br/>
            <div *ngIf="cantidadArchivos > 5" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (6) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo6" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="convenio.archivoTest6" (change)="seleccionaArchivo($event, 5)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br/>
            <div class="row line">

                <div class="col-lg-2 col-sm-2"> </div>

                <div class="col-lg-6 col-sm-1"></div>

                <div class="col-lg-3 col-sm-1">
                    <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'">
                        <button class="btn btn-primary" (click)="calcularPlanPago()">
                Calcular
            </button>
                    </div>
                </div>
                <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                    <div *ngIf="convenio.errors.required"> Presione el botón. </div>

                </div>
                <div class="col-lg-1 col-sm-1"> </div>

            </div>

            <br/>
            <div class="table-responsive">

                <table class="table" id="tablaPlan" name="tablaPlan">

                    <thead style="background-color: #0f69b4;color:white;">
                        <tr>
                            <th style="text-align: center;">Nro. cuota</th>
                            <th style="text-align: center;">Fecha de pago</th>
                            <th style="text-align: center;">Monto Cuota</th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let plan of convenio.planes | paginate: configPlan; let i = index">
                            <td style="text-align: center;">{{plan.numCuota}}</td>
                            <td style="text-align: center;">{{plan.fechaPago}}</td>
                            <td style="text-align: center;">{{plan.montoCuota}}</td>

                        </tr>
                </table>
            </div>
            <br/><br/>
            <div class="row line">
                <div class="col-lg-3">
                    <h1>Codeudores</h1>
                </div>
            </div>
            <br>
            <div class="row line">

                <div class="col-lg-2"> </div>
                <div class="col-lg-2">
                    <p>RUT Codeudor 1: </p>
                </div>

                <div class="col-lg-4">

                    <input name="rut" class="form-control" type="text" #rut="ngModel" [(ngModel)]="buscador.rut" placeholder="Ingrese el RUT (11111111-1)" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />
                </div>
                <div class="col-lg-4">
                    <button class="btn btn-primary" id="btnvalida" (click)="buscaCodeudor(buscador.rut,1)">

                        Buscar

                </button>

                </div>
            </div>
            <br/>
            <div class="row line">
                <div class="col-lg-3"> </div>
                <div class="col-lg-5">Nombre: <b>{{this.codeudor.nombreCodeudor}}</b> RUT:<b>{{this.codeudor.rutCodeudor}}</b>
                    <input type="hidden" name="idCodeudor" value={{this.codeudor.idCodeudor}}></div>
                <br>
            </div>
            <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                <div *ngIf="convenio.errors.required"> Ingrese un Codeudor. </div>

            </div>
            <br/>
            <div class="row line">

                <div class="col-lg-2"> </div>
                <div class="col-lg-2">
                    <p>RUT Codeudor 2: </p>
                </div>

                <div class="col-lg-4">

                    <input name="rut" class="form-control" type="text" #rut2="ngModel" [(ngModel)]="buscador.rut2" placeholder="Ingrese el RUT (11111111-1)" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />
                </div>
                <div class="col-lg-4">
                    <button class="btn btn-primary" id="btnvalida2" (click)="buscaCodeudor(buscador.rut2,2)">

                        Buscar

                    </button>

                </div>
                <div *ngIf="convenio.errors && convenio.touched" class="alert alert-danger">

                    <div *ngIf="convenio.errors.required"> Ingrese un codeudor. </div>

                </div>
            </div>
            <br/>
            <div class="row line">
                <div class="col-lg-3"> </div>
                <div class="col-lg-5">Nombre: <b>{{this.codeudor2.nombreCodeudor}}</b> RUT:<b>{{this.codeudor2.rutCodeudor}}</b>
                    <input type="hidden" name="idCodeudor2" value={{this.codeudor2.idCodeudor}}></div>

                <br>



                <br/>

                <br/>
                <div class="row line">

                    <div class="col-lg-2 col-sm-2"> </div>

                    <div class="col-lg-6 col-sm-1"></div>

                    <div class="col-lg-3 col-sm-1">
                        <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'">
                            <button class="btn btn-secondary" (click)="limpiarCodeudores()">
                Limpiar Codeudores
            </button>
                        </div>
                    </div>

                    <div class="col-lg-1 col-sm-1 "> </div>
                    <br/>
                </div>
                <br/>
            </div>
            <br/>
        </div>
    </form>
    <div class="container principal ">
        <br/>
        <div class="row line ">

            <div class="col-lg-5 col-sm-2 "> </div>



            <div class="col-lg-3 col-sm-1 ">
                <div *ngIf="(rol !='ROLE_EJECUTIVO_CAIP') && element == true" >
                    <button class="btn btn-success " (click)="solicitar(convenioForm) ">
                Solicitar

                 </button>
                </div>
            </div>

            <div class="col-lg-1 col-sm-1 "> </div>
            <br/>
        </div>

    </div>
    <br/>
</div>
<br/><br/><br />